import React, { useEffect, useRef, useState } from 'react';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import ProductServices from '../services/API/ProductServices';
import CategoriesService from '../services/API/CategoriesService';

export const MainFour = () => {
  const swiperRef = useRef(null);
  const sectionRef = useRef(null);
  const [products, setProducts] = useState([]);
  const [productsContent, setProductsContent] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const handleScroll = (event) => {
      if (swiperRef.current && swiperRef.current.swiper) {
        const { swiper } = swiperRef.current;
        if (swiper.isEnd && event.deltaY > 0) {
          const nextSection = sectionRef.current.nextElementSibling;
          if (nextSection) {
            nextSection.scrollIntoView({ behavior: 'smooth' });
          }
        } else if (swiper.isBeginning && event.deltaY < 0) {
          const prevSection = sectionRef.current.previousElementSibling;
          if (prevSection) {
            prevSection.scrollIntoView({ behavior: 'smooth' });
          }
        } else if (event.deltaY > 0) {
          swiper.slideNext();
        } else if (event.deltaY < 0) {
          swiper.slidePrev();
        }
        event.preventDefault();
      }
    };

    const swiperContainer = swiperRef.current?.el;
    if (swiperContainer) {
      swiperContainer.addEventListener('wheel', handleScroll, { passive: false });
    }

    return () => {
      if (swiperContainer) {
        swiperContainer.removeEventListener('wheel', handleScroll);
      }
    };
  }, [swiperRef]);

  const fetchCategoryData = async () => {
    try {
      const res = await CategoriesService.getCategoryData();
      if (res.status) {
        const earringsCategory = res.data.find(category => category.name === "Earrings");
        if (earringsCategory) {
          setProducts(earringsCategory.products);
          setProductsContent(earringsCategory);
        }
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching product data:", error);
    }
  };

  useEffect(() => {
    fetchCategoryData();
  }, []);

  return (
    <>
      <section id="sectionThree">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="pad-colddff">
                <h2>{productsContent.name}</h2>
                <p>
                {productsContent.description}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="sectionFour" ref={sectionRef} style={{ position: "relative"}}>
        <div className="container-fluid">
          <div className="row align-items-center">
            {/* <div className="col-lg-6 bgimagerdddd" style={{paddingLeft:'0px',textAlign:'left'}}>
              <img src={require('../assets/man.png')} alt="Man"/>
            </div> */}
            <div className="col-lg-12 bgimager">
              <Swiper
                ref={swiperRef}
                breakpoints={{
                  576: {
                    width: 576,
                    slidesPerView: 1,
                  },
                  768: {
                    width: 430,
                    slidesPerView: 1,
                  },
                }}
                modules={[Navigation, Pagination]}
                spaceBetween={0}
                slidesPerView={1}
                onSlideChange={() => console.log("slide change")}
              >
                {isLoading ? (
                  <div>Loading...</div>
                ) : (
                  products.map((product, index) => (
                    <SwiperSlide key={index} className="bg-color">
                      <div className='carousel-cell'>
                       <div className='box'>
                       <img className={`${'img-fluid'} ${product.name}`} src={product.productImage} alt={product.name} />
                       </div>
                      </div>
                    </SwiperSlide>
                  ))
                )}
              </Swiper>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
